// extracted by mini-css-extract-plugin
export default {"balanceBox":"WithdrawFunds_balanceBox__Hy6an","withdraw":"WithdrawFunds_withdraw__MJcub","details":"WithdrawFunds_details__JMkzq"};